<mat-form-field style="width:100%">
    <mat-label>{{label}}</mat-label>
    <input type="text"
        [placeholder]="placeholder"
        [attr.aria-label]="label"
        [required]="!search"
        matInput
        [formControl]="nodesControl"
        [minlength]="search ? 0 : NODE_NAME_MIN" [maxlength]="NODE_NAME_MAX" [size]="NODE_NAME_MAX"
        [matAutocomplete]="auto">
        @if (search && nodesControl.value) {
            <button matSuffix mat-icon-button type="button" aria-label="Clear" (click)="clear()"><mat-icon>close</mat-icon></button>
        }
        @if (nodesControl.hasError('maxLength') || nodesControl.hasError('required')) {
            <mat-error>{{getNameError()}}</mat-error>
        }@else if (nodesControl.hasError('noExistingName')) {
            <mat-error>There is an existing node with this name</mat-error>
       }

    <mat-autocomplete #auto="matAutocomplete">
        @for (option of filteredOptions | async; track option._key) {
            <mat-option [value]="option">
                <section>
                    <app-node-svg [type]="option.type"/>
                    {{option.name}}
                </section>
            </mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
